document.addEventListener("DOMContentLoaded", function () {
  /* 1. FAQ Accordion for .gp-questions (custom FAQ block) */
  var faqButtons = document.querySelectorAll(".gp-faq-q");
  faqButtons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      btn.classList.toggle("active");
      var answer = btn.nextElementSibling;
      if (answer) {
        answer.classList.toggle("show");
      }
    });
  });

  /* 2. Review Carousel (.gp-track / .gp-dots) */
  var gpTrack = document.querySelector(".gp-track");
  var gpDotsContainer = document.querySelector(".gp-dots");

  if (gpTrack && gpDotsContainer) {
    var gpIndex = 0;
    var slides = gpTrack.children;
    var total = slides.length;

    function updateGp() {
      gpTrack.style.transform = "translateX(-" + gpIndex * 100 + "%)";
      Array.prototype.forEach.call(gpDotsContainer.children, function (dot, i) {
        dot.classList.toggle("active", i === gpIndex);
      });
    }

    window.gpMove = function (delta) {
      gpIndex += delta;
      if (gpIndex < 0) gpIndex = total - 1;
      if (gpIndex >= total) gpIndex = 0;
      updateGp();
    };

    // build dots
    gpDotsContainer.innerHTML = "";
    for (var i = 0; i < total; i++) {
      (function (index) {
        var dot = document.createElement("div");
        dot.className = "gp-dot" + (index === 0 ? " active" : "");
        dot.onclick = function () {
          gpIndex = index;
          updateGp();
        };
        gpDotsContainer.appendChild(dot);
      })(i);
    }

    updateGp();
  }

  /* 3. YouTube Carousel – scroll + click-to-load */
  var scrollEl = document.getElementById("ytScroll");
  if (scrollEl) {
    var cards = Array.prototype.slice.call(
      scrollEl.querySelectorAll(".yt-card")
    );

    window.scrollByCard = function (dir) {
      if (!cards.length) return;
      var cardWidth = cards[0].offsetWidth + 16; // approximate gap
      scrollEl.scrollBy({ left: dir * cardWidth, behavior: "smooth" });
    };

    scrollEl.addEventListener("click", function (e) {
      var thumbBtn = e.target.closest(".yt-thumb");
      if (!thumbBtn) return;

      var card = thumbBtn.closest(".yt-card");
      var videoId = card && card.dataset.videoId;
      if (!videoId) return;

      // prevent duplicate iframe
      if (card.querySelector("iframe")) return;

      var iframe = document.createElement("iframe");
      iframe.src =
        "https://www.youtube.com/embed/" + videoId + "?autoplay=1&rel=0";
      iframe.loading = "lazy";
      iframe.title = "Farmer Video Testimonial";
      iframe.allow =
        "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
      iframe.allowFullscreen = true;
      iframe.style.border = "none";
      iframe.style.width = "100%";
      iframe.style.height = thumbBtn.offsetHeight + "px";
      iframe.style.borderRadius = "14px";
      iframe.referrerPolicy = "strict-origin-when-cross-origin";

      thumbBtn.replaceWith(iframe);
    });
  }

  /* 4. 60-minute Countdown Timer (Offer box) */
  (function startHourlyCountdown() {
    var countdownElement = document.getElementById("countdown");
    if (!countdownElement) return;

    var offerDuration = 60 * 60 * 1000; // 60 minutes
    var stored = localStorage.getItem("offerTargetTime");
    var targetTime = stored ? parseInt(stored, 10) : 0;
    var now = Date.now();

    if (!targetTime || isNaN(targetTime) || now > targetTime) {
      targetTime = now + offerDuration;
      localStorage.setItem("offerTargetTime", String(targetTime));
    }

    function updateCountdown() {
      var distance = targetTime - Date.now();

      if (distance <= 0) {
        countdownElement.textContent = "EXPIRED";
        localStorage.removeItem("offerTargetTime");
        clearInterval(timerId);
        return;
      }

      var totalSeconds = Math.floor(distance / 1000);
      var minutes = Math.floor(totalSeconds / 60);
      var seconds = totalSeconds % 60;

      countdownElement.textContent =
        String(minutes) + ":" + String(seconds).padStart(2, "0");
    }

    updateCountdown();
    var timerId = setInterval(updateCountdown, 1000);
  })();
});
